const StandardAbilityTree = {
  handle: 'standard',
  abilities: {
    move: {
      handle: 'move',
      unlockLevel: 1,
      // level: 1
    },
    melee_attack: {
      handle: 'melee_attack',
      unlockLevel: 1,
      // level: 1
    },
  },
};
module.exports = StandardAbilityTree;
